module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/messages-c9083be5aa3d3f197b7f569d86a15f74.svg";